import { isShowZhiGuangTong } from '@components/LocalMerchant/ZhiGuangTong/util'
import { MERCHANT_CONSULT_PHONE } from '@hlj/hlj-constant'
import { isPureUltimate, isStandard } from '@merchant-backend/util'
import cls from 'classnames'
import React, { Component } from 'react'
import { hashHistory } from 'react-router'
import FixedFooter from '../FixedFooter'
import style from './index.module.less'

// import noticeStore from '@components/LocalMerchant/NoticeChat/store'

/**
 * 当前商家为标准版、旗舰版有此 tab
 */
class Index extends Component {
  /**
   * 基础版显示立即开通
   * 标准版显示立即续费
   */
  getFooterData = () => {
    let btnText = '立即开通'

    if (isStandard()) {
      btnText = '立即续费'
    }

    return {
      btnText
    }
  }

  render() {
    const { pay_money = {} } = this.props
    const { standard_price = {} } = pay_money
    const {
      pay_fee, // 支付金额
      fee
    } = standard_price
    const _isUltimate = isPureUltimate()
    const _isStandard = isStandard()
    const { btnText } = this.getFooterData()

    return (
      <div className={style['standerd-wrap']}>
        <div className={style.center}>
          <div className={style['fix-left']} style={{ paddingRight: '60px' }}>
            <div>
              <h3 className={style.title}>店铺装修</h3>
              <p className={style.tip}>
                展示升级，信息有效触达，让你的店铺更突出
              </p>
            </div>
            <img src="https://qnm.hunliji.com/o_1d45aj6f11c5911ir14m014ejn321c.png" />
          </div>
          <div className={style['fix-right']}>
            <img src="https://qnm.hunliji.com/o_1d4nfnosd1c5g1djb13ld801dhu12.png" />
            <img
              className={style.oath}
              src="https://qnm.hunliji.com/o_1d45a2kvpk18rb9oc01gto1itj14.png"
            />
            <img
              className={style.window}
              src="https://qnm.hunliji.com/o_1d45a2kvp1fnfel1hpuj2coqg13.png"
            />
            <img
              className={style.arrive}
              src="https://qnm.hunliji.com/o_1d4nfpb0rbqbggt15f174n1r5u17.png"
            />
          </div>
        </div>

        <div className={cls(style.center, style['trans-wrap'])}>
          <div className={style['trans-left']}>
            <img src="https://qnm.hunliji.com/o_1d4s0dahjah21a1ulvc18jepv29.gif?imageView2/0/w/380" />
            <img
              className={style.recept}
              src="https://qnm.hunliji.com/o_1d45audr57jiice1p5od1m130t1h.png"
            />
          </div>
          <div className={style['trans-right']}>
            <div>
              <h3 className={style.title}>营销转化</h3>
              <p className={style.tip}>智能引导客户咨询，互动导购深度体验</p>
              <p className={style.tip}>提升客户线上咨询转化</p>
            </div>
            <img src="https://qnm.hunliji.com/o_1d45aj6f11c5911ir14m014ejn321c.png" />
          </div>
        </div>

        <div className={cls(style.center, style['expand-wrap'])}>
          <div className={style['expand-left']}>
            <div>
              <h3 className={style.title}>获客拓展</h3>
              <p className={style.tip}>
                商家专属小程序，打造微信店铺，加入核心获客生态圈
              </p>
            </div>
            <img src="https://qnm.hunliji.com/o_1d45aj6f11c5911ir14m014ejn321c.png" />
          </div>
          <div className={style['expand-right']}>
            <img src="https://qnm.hunliji.com/o_1d5454siu1f4a1jna16gm1eua177re.png" />
          </div>
        </div>

        {isShowZhiGuangTong() && (
          <div className={cls(style.center, style['analy-wrap'])}>
            <div className={style['analy-left']}>
              <img src="https://qnm.hunliji.com/o_1d4pd7a0b1c6048pno11jjaqtne.png" />
            </div>
            <div className={style['analy-right']}>
              <div>
                <h3 className={style.title}>数据中心</h3>
                <p className={style.tip} style={{ width: '234px' }}>
                  店铺后台基础数据展示，实时把握运营方向
                </p>
              </div>
              <img src="https://qnm.hunliji.com/o_1d45aj6f11c5911ir14m014ejn321c.png" />
            </div>
          </div>
        )}

        <div className={cls(style.center, style['manage-wrap'])}>
          <div className={style['manage-left']}>
            <div>
              <h3 className={style.title}>运营管理</h3>
              <p className={style.tip} style={{ width: '288px' }}>
                客服账号在线离线一键管理，多客服协作，不遗漏任何客户
              </p>
            </div>
            <img src="https://qnm.hunliji.com/o_1d45aj6f11c5911ir14m014ejn321c.png" />
          </div>
          <div className={style['manage-right']}>
            <img src="https://qnm.hunliji.com/o_1d4pd88nf2dn1jrv13arbe7i1hj.png" />
          </div>
        </div>

        {!_isUltimate &&
          !_isStandard && (
            <div className={style['order-box']}>
              <div>
                <div
                  className={style['order-submit']}
                  onClick={() =>
                    hashHistory.push('/localMerchant/marketingCenter/purchase')
                  }
                >
                  立即订购
                </div>
                <div className={style['order-phone']}>
                  咨询热线 {MERCHANT_CONSULT_PHONE}
                </div>
              </div>
            </div>
          )}

        {/* 当前商家为旗舰版，不显示购买条 */}
        {fee &&
          !_isUltimate && (
            <FixedFooter
              price={pay_fee}
              rightText={btnText}
              onClick={() => {
                hashHistory.push('/localMerchant/marketingCenter/purchase')
              }}
            />
          )}
      </div>
    )
  }
}

export default Index
